module.exports = __webpack_public_path__ + "img/role1.a43ee04c.png";